<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.name }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              class="min-button"
              @click="saveDestination('redirect')"
            >
              <i class="flaticon-floppy-disk"></i> Save
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div
          :class="{
            'col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12': hasSelectedDestination,
            'col-12': !hasSelectedDestination
          }"
        >
          <div class="card">
            <h2 class="subtitle mb-3">Search Destination</h2>
            <div class="row">
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
                <base-input
                  id="autocomplete"
                  label="Search Destination"
                  placeholder="Enter Location"
                  v-model="$v.search.$model"
                  clearable
                  :error="$v.search.$error ? `Select a valid location` : ''"
                />
              </div>
            </div>
          </div>

          <div class="card">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-4">
                <base-button
                  v-if="destinationType === 'CITY'"
                  type=""
                  class="min-button btn-line-danger abso-map-3 abso-10"
                  @click="resetPolygonPaths"
                >
                  <i class="flaticon-eraser"></i> Reset Area
                </base-button>
                <GoogleMaps
                  :location="
                    destinationType === 'CITY' && destination.slug
                      ? destination.location
                      : null
                  "
                  :paths="coordinates"
                  :autoCompleteElementId="'autocomplete'"
                  :resetPaths="resetPaths"
                  :allowPolygonDraw="destinationType === 'CITY'"
                  @updateCoordinates="onUpdateCoordinates"
                />
              </div>
            </div>
          </div>
        </div>

        <fade-transition
          v-show="hasSelectedDestination && destinationType === 'CITY'"
        >
          <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 box-flex">
            <div class="card pb-3">
              <div class="row">
                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex border-bottom mb-2"
                >
                  <div class="data-block">
                    <span class="title-block">City</span>
                    <span class="content-block"
                      >{{ destination.city || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">State</span>
                    <span class="content-block"
                      >{{ destination.state.name || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex border-bottom mb-2"
                >
                  <div class="data-block">
                    <span class="title-block">ISO State Code</span>
                    <span class="content-block"
                      >{{ destination.state.code || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">Country</span>
                    <span class="content-block"
                      >{{ destination.country.name || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex border-bottom mb-2"
                >
                  <div class="data-block">
                    <span class="title-block">ISO Country Code</span>
                    <span class="content-block"
                      >{{ destination.country.code || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">Latitude</span>
                    <span class="content-block"
                      >{{ destination.location.lat || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex border-bottom mb-2"
                >
                  <div class="data-block">
                    <span class="title-block">Longitude</span>
                    <span class="content-block"
                      >{{ destination.location.lng || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">TimeZone</span>
                    <span class="content-block"
                      >{{ destination.time_zone || "-" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fade-transition>

        <fade-transition
          v-show="hasSelectedDestination && destinationType === 'COUNTRY'"
        >
          <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 box-flex">
            <div class="card pb-3">
              <div class="row">
                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">Country</span>
                    <span class="content-block"
                      >{{ country.name || "-" }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-3 col-md-4 col-sm-4 col-12 box-flex"
                >
                  <div class="data-block">
                    <span class="title-block">ISO Country Code</span>
                    <span class="content-block"
                      >{{ country.code || "-" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fade-transition>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import GoogleMaps from "@/components/GoogleMap.vue";
import GoogleMapsLoader from "google-maps";
GoogleMapsLoader.KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
GoogleMapsLoader.LIBRARIES.push("places");
GoogleMapsLoader.WINDOW_CALLBACK_NAME = "initAutocomplete";
GoogleMapsLoader.VERSION = 3.43;
GoogleMapsLoader.LANGUAGE = "en";

import { FadeTransition } from "vue2-transitions";
import { goBack } from "@/helpers/commons.helpers";
import { handleApiError } from "@/core/services";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { CountriesAPI, DestinationsAPI } from "@/core/api";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewDestination",
  data() {
    return {
      destination: {
        country: {
          code: "",
          name: "",
          slug: ""
        },
        state: {
          code: "",
          name: ""
        },
        city: "",
        slug: "",
        article: {
          image: "",
          thumbnail: "",
          description: "",
          content: ""
        },
        location: {
          lat: null,
          lng: null
        },
        time_zone: "",
        languages: [],
        geometry: {
          type: "Polygon",
          coordinates: []
        },
        iata_code: "",
        visibilityStatus: "PENDING"
      },
      country: {
        code: "",
        name: "",
        slug: "",
        article: {
          image: "",
          thumbnail: "",
          description: "",
          content: ""
        },
        citiesCount: 0,
        languages: [],
        visibilityStatus: "PENDING"
      },
      destinationType: "CITY",
      destinationCopy: {},
      onSave: false,
      coordinates: [],
      resetPaths: false,
      search: "",
      hasSelectedDestination: false
    };
  },
  mounted() {
    GoogleMapsLoader.load(google => {
      this.initializeAutocomplete(google);
    });
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },
      {
        text: "Destinations",
        to: "/tools/destinations"
      },
      {
        text: "New Destination",
        active: true
      }
    ];
    this.setItemsBread(bread);
    if (this.destinationType == "CITY") {
      this.destinationCopy = lodash.cloneDeep(this.destination);
    } else {
      this.countryCopy = lodash.cloneDeep(this.country);
    }
  },
  methods: {
    async saveDestination(action, route = null) {
      if (!this.$v.search.$invalid) {
        if (this.destinationType == "CITY") {
          if (!this.$v.destination.$invalid) {
            let destination = lodash.cloneDeep(this.destination);
            await this.createDestination(destination, route, action);
          } else {
            this.$v.destination.$touch();
            this.$notify({
              type: "warning",
              title: "Important!",
              message: "Please complete the required attributes",
              icon: "flaticon-warning-1"
            });
          }
        } else if (this.destinationType == "COUNTRY") {
          if (!this.$v.country.$invalid) {
            let country = lodash.cloneDeep(this.country);
            await this.createCountry(country, route, action);
          } else {
            this.$v.country.$touch();
            this.$notify({
              type: "warning",
              title: "Important!",
              message: "Please complete the required attributes",
              icon: "flaticon-warning-1"
            });
          }
        }
      } else {
        this.$v.search.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please enter a valid location",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createDestination(destination, route) {
      try {
        this.setLoad(true);
        let { data } = await DestinationsAPI.createDestination(
          destination,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let { destination } = data.data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The destination has been Saved",
            icon: "flaticon-check-mark"
          });
          this.$router.push(
            route ? route : `/tools/destinations/${destination._id}?type=CITY`
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async createCountry(country, route) {
      try {
        this.setLoad(true);
        let { data } = await CountriesAPI.createCountry(
          country,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let { country } = data.data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The country has been Saved",
            icon: "flaticon-check-mark"
          });
          this.$router.push(
            route ? route : `/tools/destinations/${country._id}?type=COUNTRY`
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    async getCountryByCode(countryCode) {
      try {
        let { data } = await CountriesAPI.getCountryByCode(
          countryCode,
          this.sesion.token
        );
        return data.status ? data.data : null;
      } catch (error) {
        return null;
      }
    },
    async checkCountrySlugIsDuplicate(countrySlug) {
      try {
        let { data } = await CountriesAPI.checkCountrySlugIsDuplicate(
          countrySlug,
          this.sesion.token
        );
        return data.status ? data.data.isDuplicate : false;
      } catch (error) {
        return false;
      }
    },
    async checkDestinationSlugIsDuplicate(countrySlug, destinationSlug) {
      try {
        let { data } = await DestinationsAPI.checkDestinationSlugIsDuplicate(
          countrySlug,
          destinationSlug,
          this.sesion.token
        );
        return data.status ? data.data.isDuplicate : false;
      } catch (error) {
        return false;
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getAddressComponent(types = [], addressComponents = []) {
      if (!Array.isArray(types) || !Array.isArray(addressComponents)) {
        return null;
      }

      return (
        addressComponents.find(
          component =>
            Array.isArray(component.types) &&
            component.types.some(type => types.includes(type))
        ) || null
      );
    },
    convertToSlug(destinationName) {
      return destinationName
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    async getTimeZone(countrySlug, destinationSlug, payload) {
      try {
        let { data } = await DestinationsAPI.getTimezoneByCoordinates(
          countrySlug,
          destinationSlug,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return data.data ? data.data.timeZoneId : "";
        }
        return "";
      } catch (error) {
        console.error("Error in Time Zone API request:", error);
        return "";
      }
    },
    async generateCityDetails(place) {
      const components = place.address_components;

      const countryComponent = this.getAddressComponent(
        ["country"],
        components
      );
      const stateComponent = this.getAddressComponent(
        ["administrative_area_level_1", "administrative_area_level_2"],
        components
      );
      const cityComponent = this.getAddressComponent(
        ["locality", "administrative_area_level_3"],
        components
      );

      if (!countryComponent) {
        console.error("Country component not found in place details.");
        return;
      }

      if (!stateComponent) {
        console.error("State component not found in place details.");
        return;
      }

      if (!cityComponent) {
        console.error("City component not found in place details.");
        return;
      }
      // Extracting necessary details
      const countryCode = countryComponent.short_name;

      // State details
      const stateName = stateComponent.long_name;
      const stateSlug = this.convertToSlug(stateName) || "";

      // City details
      const cityName = cityComponent.short_name;
      const citySlug = this.convertToSlug(cityName);

      // Get time zone
      const timeZone = await this.getTimeZone(countryCode, citySlug, {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      });

      return {
        slug: citySlug,
        name: cityName,
        time_zone: timeZone,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        state: {
          name: stateName,
          slug: stateSlug
        },
        countryCode: countryCode
      };
    },
    async generateCountryDetails(place) {
      const components = place.address_components;

      const countryComponent = this.getAddressComponent(
        ["country"],
        components
      );
      if (!countryComponent) {
        console.error("Country component not found in place details.");
        return;
      }
      // Extracting necessary details
      const countryName = countryComponent.long_name;
      const countryCode = countryComponent.short_name;
      const countrySlug = this.convertToSlug(countryName);

      return {
        slug: countrySlug,
        name: countryName,
        code: countryCode
      };
    },
    async populatePlace(place) {
      if (this.destinationType === "CITY") {
        const cityDetails = await this.generateCityDetails(place);
        const [isCityDuplicate, countryDetails] = await Promise.all([
          this.checkDestinationSlugIsDuplicate(
            cityDetails.countryCode,
            cityDetails.slug
          ),
          this.getCountryByCode(cityDetails.countryCode)
        ]);
        if (isCityDuplicate || !countryDetails) {
          this.search = "";
          const message = isCityDuplicate
            ? "Destination is already created"
            : "Country for this destination does not exist. Please create the country first.";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: message,
            icon: "flaticon-warning-1"
          });
          return;
        }

        this.destination.city = cityDetails.name;
        this.destination.location.lat = cityDetails.lat;
        this.destination.location.lng = cityDetails.lng;
        this.destination.state.name = cityDetails.state.name;
        this.destination.state.slug = cityDetails.state.slug;
        this.destination.country.name = countryDetails.name;
        this.destination.country.code = countryDetails.code;
        this.destination.country.slug = countryDetails.slug;
        this.destination.slug = cityDetails.slug;
        this.destination.time_zone = cityDetails.time_zone || "";
        this.hasSelectedDestination = true;
      } else if (this.destinationType === "COUNTRY") {
        const countryDetails = await this.generateCountryDetails(place);
        let isCountryDuplicate = await this.checkCountrySlugIsDuplicate(
          countryDetails.slug
        );
        if (isCountryDuplicate) {
          this.search = "";
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Country is already created!",
            icon: "flaticon-warning-1"
          });
          return;
        }
        this.country.name = countryDetails.name;
        this.country.code = countryDetails.code;
        this.country.slug = countryDetails.slug;
        this.hasSelectedDestination = true;
      }
    },
    initializeAutocomplete(google) {
      const input = document.getElementById("autocomplete");

      this.autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["geocode"]
      });

      this.autocomplete.addListener("place_changed", this.handlePlaceSelection);
    },
    async handlePlaceSelection() {
      const place = this.autocomplete.getPlace();
      this.destinationType = this.classifyDestinationType(place);
      this.search = place.formatted_address;
      if (this.destinationType !== "UNKNOWN") {
        await this.populatePlace(place);
      } else {
        this.search = "";
        this.$notify({
          type: "warning",
          title: "Importante",
          message: "El destino debe ser una ciudad o un país.",
          icon: "flaticon-warning-1"
        });
      }
    },
    classifyDestinationType(place) {
      const cityTypes = ["locality", "administrative_area_level_3"];
      if (place.types.some(type => cityTypes.includes(type))) {
        return "CITY";
      }
      const countryTypes = ["country"];
      if (place.types.some(type => countryTypes.includes(type))) {
        return "COUNTRY";
      }

      return "UNKNOWN";
    },
    async resetPolygonPaths() {
      let { value } = await Swal.fire({
        title: "Reset Destination Area",
        text: "Are you sure do you want to reset this Destination Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.resetPaths = true;
      }
    },
    onUpdateCoordinates(coordinates = []) {
      if (coordinates.length === 0) {
        this.destination.geometry.coordinates = [];
        this.resetPaths = false;
        return;
      }
      this.destination.geometry.type = "Polygon";
      this.destination.geometry.coordinates = this.mapCoordinates(coordinates);
    },
    mapCoordinates(coordinates = []) {
      return coordinates.map(point => {
        return { lat: point.lat, lng: point.lng };
      });
    },
    async detectChanges(to, from, next) {
      let isEqual =
        this.destinationType == "CITY"
          ? lodash.isEqual(this.destination, this.destinationCopy)
          : lodash.isEqual(this.country, this.countryCopy);

      if (!isEqual && !this.onSave) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The destination has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          cancelButtonClass: "btn btn-secondary btn-small-one",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDestination("redirect", to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    isInDestinationsModule(modules = []) {
      if (!modules.includes("destinations")) {
        this.setDestinationSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    ...mapMutations([
      "setModule",
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDestinationSearchCriteria"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    WSelect,
    GoogleMaps,
    FadeTransition
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  validations: {
    search: {
      required
    },
    country: {
      slug: {
        required,
        maxLength: maxLength(160)
      },
      images: {
        minLength: minLength(1),
        maxLength: maxLength(8)
      },
      article: {
        content: {
          minLength: minLength(200),
          maxLength: maxLength(20000)
        },
        description: {
          minLength: minLength(50),
          maxLength: maxLength(160)
        }
      },
      visibilityStatus: {
        required
      }
    },
    destination: {
      slug: {
        required,
        maxLength: maxLength(160)
      },
      iata_code: {
        maxLength: maxLength(5)
      },
      images: {
        minLength: minLength(1),
        maxLength: maxLength(8)
      },
      article: {
        content: {
          minLength: minLength(200),
          maxLength: maxLength(20000)
        },
        description: {
          minLength: minLength(50),
          maxLength: maxLength(160)
        }
      },
      visibilityStatus: {
        required
      },
      languages: {
        required: false,
        $each: {
          name: {
            minLength: minLength(2),
            maxLength: maxLength(45)
          },
          code: {
            minLength: minLength(2),
            maxLength: maxLength(6)
          }
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInDestinationsModule(to.meta.modules);
    this.detectChanges(to, from, next);
  }
};
</script>
